import ClientRegistrationForm from '../../../components/Sales/ClientRegistration/ClientRegistrationForm'
import React, { Component } from 'react'
import { Breadcrumb, Card, Layout, Row } from 'antd'

const { Content } = Layout

class ClientRegistrationApproval extends Component {
  render() {
    const { fetching, list } = this.props
    return (
      <Content style={{ margin: '0px 0px' }}>
        <Card>
          <Row>
            <Breadcrumb>
              <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
              <Breadcrumb.Item>Client</Breadcrumb.Item>
              <Breadcrumb.Item>Registration</Breadcrumb.Item>
            </Breadcrumb>
          </Row>
        </Card>
        <Row gutter={16} style={{ padding: 10 }}>
          <Card title={<h1>Client Registration</h1>}>
            <ClientRegistrationForm loading={fetching} supplierRegistration={list} {...this.props} />
          </Card>
        </Row>
      </Content>
    )
  }
}

export default ClientRegistrationApproval
